import config from '../../common/config'

const ssoServerHost = config.sso.SERVER_HOST

export default {
  blocks: [
    {
      key: 'account',
      title: 'Hi, {{username}}',
      entries: [
        {
          key: 'profile',
          label: 'Profile',
          path: '/user/{{username}}'
        },
        {
          key: 'settings',
          label: 'Settings',
          path: '/user/{{username}}/personal_information/edit'
        },
        {
          key: 'downloads',
          label: 'Downloads',
          path: '/downloads'
        },
        {
          key: 'favorites',
          label: 'Favorites',
          path: '/favorites'
        },
        {
          key: 'collections',
          label: 'Collections',
          path: '/collections/manage'
        },
        {
          key: 'addCredit',
          label: 'Add Credit',
          path: '/payment/deposit/new',
          showCredit: true,
          creditLabel: 'Current credit:'
        }
      ]
    },
    {
      key: 'author',
      title: 'Author Settings', // TODO
      requires: 'userIsAuthor',
      entries: [
        {
          key: 'dashboard',
          label: 'Dashboard',
          path: '/author_dashboard',
          requires: 'hasAuthorPermissionsInCurrentSite'
        },
        {
          key: 'upload',
          label: 'Upload',
          path: '/content/upload',
          requires: 'canUploadInCurrentSite'
        },
        {
          key: 'portfolio',
          label: 'Portfolio',
          path: '/user/{{username}}/portfolio',
          requires: 'canViewPortfolio'
        },
        {
          key: 'earnings',
          label: 'Earnings',
          path: '/user/{{username}}/earnings'
        },
        {
          key: 'statement',
          label: 'Statement',
          path: '/user/{{username}}/statement'
        },
        {
          key: 'withdrawals',
          label: 'Withdrawals',
          path: '/accounts/withdrawal/new'
        }
      ]
    },
    {
      key: 'buyer',
      requires: 'userIsNotAuthor',
      entries: [
        {
          key: 'become-author',
          label: 'Become an Author',
          path: '/become-an-author'
        }
      ]
    },
    {
      key: 'logout',
      entries: [
        {
          key: 'sign_out',
          label: 'Sign Out',
          path: `${ssoServerHost}/sign_out?to={{currentSite}}`
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./config/layout/userMenu.js